import TexMergeVS from "./TexMerge.vs";
import TexMergeFS from "./TexMerge.fs";
import { ShaderDataType } from "../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { LayaGL } from "../../layagl/LayaGL";
import { RenderState } from "../../RenderDriver/RenderModuleData/Design/RenderState";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { SubShader } from "../../RenderEngine/RenderShader/SubShader";
import { VertexMesh } from "../../RenderEngine/RenderShader/VertexMesh";
export class TextureMergeShaderInit {
    static init() {
        const attributeMap = {
            "a_PositionTexcoord": [VertexMesh.MESH_POSITION0, ShaderDataType.Vector4]
        };
        const uniformMap = {
            "u_MainTex": ShaderDataType.Texture2D,
            "u_OffsetScale": ShaderDataType.Vector4,
        };
        this.LINEAR_TO_GAMMA = Shader3D.getDefineByName("LINEAR_TO_GAMMA");
        this.GAMMA_TO_LINEAR = Shader3D.getDefineByName("GAMMA_TO_LINEAR");
        this._sdNotChange = LayaGL.renderDeviceFactory.createShaderData(null);
        this._sdGammaToLinear = LayaGL.renderDeviceFactory.createShaderData(null);
        this._sdGammaToLinear.addDefine(this.GAMMA_TO_LINEAR);
        this._sdLinearToGamma = LayaGL.renderDeviceFactory.createShaderData(null);
        this._sdLinearToGamma.addDefine(this.LINEAR_TO_GAMMA);
        const shader = Shader3D.add("TexMerge");
        const subShader = new SubShader(attributeMap, uniformMap);
        shader.addSubShader(subShader);
        const blitPass = subShader.addShaderPass(TexMergeVS, TexMergeFS);
        const blitState = blitPass.renderState;
        blitState.depthTest = RenderState.DEPTHTEST_ALWAYS;
        blitState.depthWrite = false;
        blitState.cull = RenderState.CULL_NONE;
        blitState.blend = RenderState.BLEND_DISABLE;
    }
}
